import React, { useState, useEffect, useRef, useCallback } from 'react';
import Checkbox from './Checkbox';
import DashboardDropdown, { DashboardDropdownOption, useDismissibleDropdown } from './DropdownFrame';
import { useDropdown } from '../../contexts/DropdownContext';

import { ReactComponent as OffImage } from '../../assets/icons/drop-down-checkbox-off.svg';
import { ReactComponent as OnImage } from '../../assets/icons/drop-down-checkbox-on.svg';

const MultiSelectDropdown = ({ id, title, options, selectedOptions, setSelectedOptions }) => {
  const dropdownRef = useRef(null);
  const [internalSelectedOptions, setInternalSelectedOptions] = useState(selectedOptions || []);
  const { openDropdown, closeDropdown, isDropdownOpen } = useDropdown();
  const dropdownId = id || title.toLowerCase().replace(/\s+/g, '-');
  const optionsVisible = isDropdownOpen(dropdownId);

  useEffect(() => {
    setInternalSelectedOptions(selectedOptions || []);
  }, [options, selectedOptions]);

  const commit = useCallback(() => {
    closeDropdown(dropdownId);
    setSelectedOptions(internalSelectedOptions);
  }, [closeDropdown, dropdownId, internalSelectedOptions, setSelectedOptions]);

  useDismissibleDropdown(optionsVisible, dropdownRef, commit);

  const toggleOptions = () => {
    if (optionsVisible) {
      commit();
      return;
    }

    openDropdown(dropdownId);
  };

  return (
    <DashboardDropdown
      title={title}
      value={(
          <>
            <span>{internalSelectedOptions.length}</span>
          <span className="filter-dropdown__meta">
            / {options.length}
          </span>
        </>
      )}
      isOpen={optionsVisible}
      onToggle={toggleOptions}
      dropdownRef={dropdownRef}
    >
      <DashboardDropdownOption
        leading={(
          <Checkbox
            on={OnImage}
            off={OffImage}
            checked={internalSelectedOptions.length === options.length}
            onChange={() => {}}
          />
        )}
        onClick={() => {
          if (internalSelectedOptions.length === options.length) {
            setInternalSelectedOptions([]);
          } else {
            setInternalSelectedOptions(options);
          }
        }}
      >
        All
      </DashboardDropdownOption>

      {options.map((option, index) => (
        <DashboardDropdownOption
          key={index}
          leading={(
            <Checkbox
              on={OnImage}
              off={OffImage}
              checked={internalSelectedOptions.includes(option)}
              onChange={() => {}}
            />
          )}
          onClick={() => {
            const newSelectedOptions = internalSelectedOptions.includes(option)
              ? internalSelectedOptions.filter((selectedOption) => selectedOption !== option)
              : [...internalSelectedOptions, option];
            setInternalSelectedOptions(newSelectedOptions);
          }}
        >
          {option}
        </DashboardDropdownOption>
      ))}
    </DashboardDropdown>
  );
};

export default MultiSelectDropdown;
